export default __webpack_public_path__ + "static/media/pro2.f1bf7df5.png";